import { createContext, useContext, useMemo } from 'react';
import useStore from '@pkg/auth/useStore';
import AppLoading from '@/components/AppLoading';
import useUserSurveys from './queries/useUserSurveys';

export const UserContext = createContext();
export const useUserContext = () => useContext(UserContext);

const UserProvider = ({ children }) => {
  const me = useStore((state) => state.me);

  const { surveys, isLoading: isSurveysLoading } = useUserSurveys(me?.id);
  const isLoading = isSurveysLoading;

  const context = useMemo(() => {
    return {
      surveys,
      isLoading,
    };
  }, [surveys, isLoading]);

  if (isLoading) {
    return (
      <AppLoading
        reason="UserProvider.isLoading"
        messages={['Pulling up your account...', '⚡ Almost ready to roll!']}
      />
    );
  }

  return (
    <UserContext.Provider value={context}>{children}</UserContext.Provider>
  );
};

export default UserProvider;
